<template>
  <div class="bg-layer" @click="bgclick"></div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatBackground",
  methods: {
    bgclick: function (event) {
      const evt = new CustomEvent("ui-background-click", event);
      document.dispatchEvent(evt);
    }
  }
});
</script>
